import React from "react";

import { Icon } from "semantic-ui-react";
import { toast } from 'react-toastify';
import Resize from "react-image-file-resizer";

function ButtonPushNewImage(props) {

    function onPushNewImage(e) {
        if (e.target.files.length > 0) {
            let nameFile = e.target.files[0].name.split(".");
            if (["png", "jpg", "jpeg"].indexOf(nameFile[nameFile.length - 1]) === -1) {
                toast.error((props.lang === "es") ? 'Extensión de archivo invalida (.png, .jpg, .jpeg)' : 'Invalid extension file (.png, .jpg, .jpeg)', {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
            } else {
                onFileResize(e.target.files[0], window.screen.width, 1080);
            }
        }
    }

    // function b64toBlob(b64Data, contentType = '', sliceSize = 512) {
    //     const byteCharacters = atob(b64Data);
    //     const byteArrays = [];
    //     for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    //         const slice = byteCharacters.slice(offset, offset + sliceSize);
    //         const byteNumbers = new Array(slice.length);
    //         for (let i = 0; i < slice.length; i++) {
    //             byteNumbers[i] = slice.charCodeAt(i);
    //         }
    //         const byteArray = new Uint8Array(byteNumbers);
    //         byteArrays.push(byteArray);
    //     }
    //     return new Blob(byteArrays, { type: contentType });
    // }

    function onFileResize(file, width, height) {
        Resize.imageFileResizer(
            file,
            width,
            height,
            "JPEG",
            70,
            0,
            (uri) => {
                if (new Blob([uri]).size > 700000) {
                    toast.error('limit file size 700KB (your file ' + Math.round((new Blob([uri]).size) / 1000) + 'KB)', {
                        position: "top-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                    });
                } else {
                    let images = JSON.parse(localStorage.getItem("images"));
                    let totalSize = localStorage.getItem("totalSize");
                    if (totalSize === null) {
                        totalSize = 0;
                    } else {
                        totalSize = parseInt(totalSize);
                    }
                    totalSize += new Blob([uri]).size;
                    localStorage.setItem("totalSize", totalSize);

                    let numImage = parseInt(images.length + 1);
                    if (numImage < 10) {
                        numImage = `0${numImage}`;
                    }
                    images.push({ full: uri, thumbnail: "", name: "bg-" + numImage, fav: false });
                    localStorage.setItem("images", JSON.stringify(images));
                    props.onPushImage(images);

                    // const contentType = 'image/jpeg';
                    // const blob = this.b64toBlob(uri.split("base64,")[1], contentType);
                    // const blobUrl = URL.createObjectURL(blob);
                    // $("div#root").css({ backgroundImage: `url(${blobUrl})` })
                }
            },
            "base64",
        );
    }

    return (
        <div>
            <label htmlFor="file-to-push" title={(props.lang === "es") ? "Subir una imagen nueva" : "Push new Image"}><Icon circular name='plus' color="orange" size="big" /></label>
            <input onChange={onPushNewImage} type="file" style={{ display: "none" }} name="file-to-push" id="file-to-push" />
        </div>
    );
}

export default ButtonPushNewImage;